<template>
<div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
  <div class="carousel">
    <img src="../../assets/images/developerCommunity/dev_banner.jpg" alt="">
  </div>
  <div class="case_main">
    <div class="case_top">
      <div class="case_title">MQTT物联网通讯协议介绍</div>
      <div class="case_time">
        <span><img src="../../assets/images/developerCommunity/dev_time.png" alt="">2020/06/12</span>
        <span><img src="../../assets/images/developerCommunity/dev_people.png" alt="">Eiiplat 平台</span>
      </div>
      <hr>
    </div>
    <div class="case_detail">
      <div class="model">
        <div class="model_title">【概述】</div>
        <div class="section">
          MQTT（Message Queuing Telemetry Transport，消息队列遥测传输协议），是一种基于发布/订阅（publish/subscribe）模式的“轻量级”通讯协议，该协议构建于TCP/IP协议上，由IBM在1999年发布。MQTT最大优点在于，可以以极少的代码和有限的带宽，为连接远程设备提供实时可靠的消息服务。作为一种低开销、低带宽占用的即时通讯协议，使其在物联网、小型设备、移动应用等方面有较广泛的应用。
          MQTT是一个基于客户端-服务器的消息发布/订阅传输协议.
        </div>
        <div class="section">
          MQTT是一个基于客户端-服务器的消息发布/订阅传输协议。MQTT协议是轻量、简单、开放和易于实现的，这些特点使它适用范围非常广泛。在很多情况下，包括受限的环境中，如：机器与机器（M2M）通信和物联网（IoT）。其在，通过卫星链路通信传感器、偶尔拨号的医疗设备、智能家居、及一些小型化设备中已广泛使用。
        </div>

        <div class="section">
          MQTT协议是轻量、简单、开放和易于实现的，这些特点使它适用范围非常广泛。在很多情况下，包括受限的环境中，如：机器与机器（M2M）通信和物联网（IoT）。其在，通过卫星链路通信传感器、偶尔拨号的医疗设备、智能家居、及一些小型化设备中已广泛使用。
        </div>

      </div>
      <div class="model">
        <div class="model_title">【设计规范】</div>
        <div class="section">
          由于物联网的环境是非常特别的，所以MQTT遵循以下设计原则：<br />
          （1）精简，不添加可有可无的功能；<br />
          （2）发布/订阅（Pub/Sub）模式，方便消息在传感器之间传递；<br />
          （3）允许用户动态创建主题，零运维成本；<br />
          （4）把传输量降到最低以提高传输效率；<br />
          （5）把低带宽、高延迟、不稳定的网络等因素考虑在内；<br />
          （6）支持连续的会话控制；<br />
          （7）理解客户端计算能力可能很低；<br />
          （8）提供服务质量管理；<br />
          （9）假设数据不可知，不强求传输数据的类型与格式，保持灵活性。
        </div>

      </div>
      <div class="model">
        <div class="model_title">【主要特性】</div>
        <div class="section">
           MQTT协议工作在低带宽、不可靠的网络的远程传感器和控制设备通讯而设计的协议，它具有以下主要的几项特性：<br />
          （1）使用发布/订阅消息模式，提供一对多的消息发布，解除应用程序耦合。<br />
           这一点很类似于XMPP，但是MQTT的信息冗余远小于XMPP，,因为XMPP使用XML格式文本来传递数据。<br />
          （2）对负载内容屏蔽的消息传输。<br />
          （3）使用TCP/IP提供网络连接。<br />
           主流的MQTT是基于TCP连接进行数据推送的，但是同样有基于UDP的版本，叫做MQTT-SN。这两种版本由于基于不同的连接方式，优缺点自然也就各有不同了。<br />
          （4）有三种消息发布服务质量：<br />
           “至多一次”，消息发布完全依赖底层TCP/IP网络。会发生消息丢失或重复。这一级别可用于如下情况，环境传感器数据，丢失一次读记录无所谓，因为不久后还会有第二次发送。这一种方式主要普通APP的推送，倘若你的智能设备在消息推送时未联网，推送过去没收到，再次联网也就收不到了。<br />
           “至少一次”，确保消息到达，但消息重复可能会发生。<br />
           “只有一次”，确保消息到达一次。在一些要求比较严格的计费系统中，可以使用此级别。在计费系统中，消息重复或丢失会导致不正确的结果。这种最高质量的消息发布服务还可以用于即时通讯类的APP的推送，确保用户收到且只会收到一次。<br />
          （5）小型传输，开销很小（固定长度的头部是2字节），协议交换最小化，以降低网络流量。<br />
           这就是为什么在介绍里说它非常适合“在物联网领域，传感器与服务器的通信，信息的收集”，要知道嵌入式设备的运算能力和带宽都相对薄弱，使用这种协议来传递消息再适合不过了。<br />
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'DeveloperDzxDetail',
  data() {
    return {
      detailId: this.$route.params.id,
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.init()
  },
  methods: {
    init() {
      console.log(this.detailId)
    }
  }
}
</script>

<style lang="scss">
.carousel {
  img {
    width: 100%;
  }
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.4rem;
    }

    .case_time {
      display: flex;

      span {
        font-size: 0.18rem;
        color: #999;
        margin-right: 0.35rem;
        display: flex;
        align-items: center;
      }

      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin: 0.4rem 0;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;

    img {
      width: 100%;
    }

    .model {
      margin-top: 0.2rem;

      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }

      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/DeveloperDzxDetail.vue